import gql from 'graphql-tag';

const LIST_ORGS_TREE = gql`
  query listOrgsTree($parentid: ID!, $skip: Int, $first: Int) {
    orgs(
      first: $first
      skip: $skip
      where: {
        AND: [
          { OR: [{ parentOrg_some: { id: $parentid } }, { id: $parentid }] }
          { OR: [{ status: null }, { status_not: ARCHIVED }] }
        ]
      }
      orderBy: name_ASC
    ) {
      id
      name
      parentOrg {
        id
        name
        level
      }
      config {
        isAdmin
        isHybrid
      }
      roles(first: 1, where: { isMaster: true }) {
        id
        isMaster
        roleItems(first: 15) {
          id
          feature
          actions
        }
      }
      pricingModel {
        id
        model
        hasContract
        cpmList {
          id
          type
          advertiserCPM
          contractCPM
        }
        auctionPlus {
          id
          advertiserPercentage
          contractPercentage
        }
      }
    }
  }
`;

export default LIST_ORGS_TREE;
